import { Component } from '@angular/core';
import { AdminLearnerMapsListComponent } from '../../admin-learner-maps-list/admin-learner-maps-list.component';

@Component({
  selector: 'app-lmlist-type-popup',
  templateUrl: './lmlist-type-popup.component.html',
  styleUrls: ['./lmlist-type-popup.component.scss']
})
export class LmlistTypePopupComponent {

  constructor(public lmCompo: AdminLearnerMapsListComponent) {}

  public close() {
    this.lmCompo.showListLmTypeModal = false;
  }

  getLmCount(typeId: number): number {
    if (!this.lmCompo.allmaps || !typeId) return 0;
    return this.lmCompo.allmaps.filter(m => m.learner_map_type_id === typeId).length;
  }
}
